/**
 * SMBSignupModal validation utilities
 *
 * Form validation rules for the SMB signup form
 */
import { isValidPassword } from '@/auth';
import { isEmailValid } from '@/utils';
import { hasOnlyLetters } from '@/utils/reducer';

import { SMBSignupFormData } from '../types';

export interface ValidationErrors {
  first_name?: string;
  last_name?: string;
  email?: string;
  password?: string;
  accept_privacy_and_terms_of_use?: string;
}

/**
 * Validate SMB signup form data
 */
export function validateSMBSignupForm(values: Partial<SMBSignupFormData>): ValidationErrors {
  const errors: ValidationErrors = {};

  // First name validation
  const firstName = (values.first_name || '').trim();
  if (!firstName) {
    errors.first_name = 'Required';
  } else if (!hasOnlyLetters(firstName)) {
    errors.first_name = 'Only letters allowed';
  }

  // Last name validation
  const lastName = (values.last_name || '').trim();
  if (!lastName) {
    errors.last_name = 'Required';
  } else if (!hasOnlyLetters(lastName)) {
    errors.last_name = 'Only letters allowed';
  }

  // Email validation
  if (!values.email) {
    errors.email = 'Required';
  } else if (!isEmailValid(values.email)) {
    errors.email = 'Invalid email address';
  }

  // Password validation
  if (!values.password || !isValidPassword(values.password)) {
    errors.password = 'Password does not meet the requirements';
  }

  // Privacy & ToU checkbox validation
  if (!values.accept_privacy_and_terms_of_use) {
    errors.accept_privacy_and_terms_of_use = 'Required';
  }

  return errors;
}
